import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import PasswordResetModal from "./modals/PasswordResetModal";
import { useAuthContext } from "../../hooks/useAuthContext";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [err, setErr] = useState("");
  const [serverErr, setServerErr] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [tokenExists, setTokenExists] = useState(false);
  const { token } = useParams();
  const [passwordResetModal, setPasswordResetModal] = useState(false);
  const { user, dispatch } = useAuthContext();

  useEffect(() => {
    const getData = async () => {
      try {
        if (user) {
          const checkStatusResponse = await axios.get(
            `${ApiConnectionString}/api/users/checkstatus`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          );
          if (checkStatusResponse.status == 200) {
            dispatch({ type: "LOGOUT" });
          }
        }
      } catch {}

      try {
        const response = await axios.get(
          `${ApiConnectionString}/api/ForgotPasswordToken/${token}`
        );
        if (response.status === 200) {
          setTokenExists(response.data);

          if (response.data == false) {
            setServerErr("Invalid link");
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setServerErr(error.response.data);
        } else {
          console.error(error);
          setServerErr("An unexpected error occurred.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      getData();
    } else {
      setIsLoading(false);
    }
  }, [user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    let err = false;
    if (!validatePassword(password)) {
      setErr(
        "Password must be at least 8 characters long and include a lowercase letter, an uppercase letter, a number, and a special character."
      );
      err = true;
    } else {
      setErr("");
    }
    if (password != confirmPassword) {
      setErr("Passwords do not match");
      err = true;
    }
    if (password.length == 0 || confirmPassword.length == 0) {
      setErr("All feilds must be filled");
      err = true;
    }

    if (!err) {
      const resetPassword = {
        token,
        password,
      };

      const respose = await axios.put(
        `${ApiConnectionString}/api/resetpassword`,
        resetPassword
      );
      if (respose.status == 200) {
        setPasswordResetModal(true);
      }
    }
  };

  const validatePassword = (password) => {
    const passwordRequirements =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRequirements.test(password);
  };

  if (tokenExists) {
    return (
      <div className="container mt-5 bg-white">
        <div className="fontSize18 fw-bold py-1 mb-2 blueBanner text-center">
          <p>Reset Your Password</p>
        </div>
        <div className="d-flex justify-content-center">
          <form onSubmit={handleSubmit}>
            <div className="form-group d-flex align-items-center">
              <div className="me-3">
                <p className="fw-bold red-text">New Password</p>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div>
                <p className="fw-bold red-text">Confirm New Password</p>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="saveChanges-button my-4">
              Reset Password
            </button>
          </form>
          {err && <p className="text-center mt-3 text-danger">{err}</p>}
        </div>
        {passwordResetModal && <PasswordResetModal />}
        {isLoading && <LoadingSpinner />}
      </div>
    );
  } else {
    return (
      <div className="container mt-5">
        {serverErr && (
          <p className="text-center mt-3 text-danger">{serverErr}</p>
        )}

        {isLoading && <LoadingSpinner />}
      </div>
    );
  }
}
